import axios, { AxiosInstance } from "axios";
import { getAxiosInstance } from "../utils";
import { PublicConfigurationsResponse } from "./dto/PublicConfigurations.dto";
import { HostUtils } from "../../../utils/host.utils";

export default class PublicConfigurationsService {
    private axiosInstance: AxiosInstance = axios.create()

    _init(baseURL: string, token: string | null): void {
        this.axiosInstance = getAxiosInstance({
            baseURL,
            token
        })
    }

    async fetchPublicConfigurations(): Promise<PublicConfigurationsResponse> {
        const response = await this.axiosInstance.get<PublicConfigurationsResponse>(
            `/configurations/public`, { params: { hostname: HostUtils.getHostname() }}
        )
        return response.data
    }
}